
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "../../../models/app-filter.model";
import { FeriadoAreaComumDTO } from "../../../models/feriadoAreaComumDTO";
import { AbAreaComum } from "app/abstract/full-pages/area-comum/area-comum.abstract";

@Injectable({ providedIn: 'root' })
export class AreaComumService extends AbAreaComum {

  public getAllAreaComum(): Observable<any> {
    return this.get(`areacomum/all`);
  }

  public getAllAreaComumAgendavel(): Observable<any> {
    return this.get(`areacomum/all/agendavel`);
  }

  public getAllAreaComumDTOAgendavel(): Observable<any> {
    return this.get(`areacomum/all/agendavel_dto`);
  }

  public getAllAreaComumDTOPorteiroAgendavel(): Observable<any> {
    return this.get(`areacomum/all/porteiro/agendavel_dto`);
  }

  public getAllAreaComumDTOPorteiroAgendavelFilter(filter: AppFilter): Observable<any> {
    return this.get(`areacomum/all/porteiro/agendavel_dto/${filter.encode()}`);
  }

  public getAreaComumById(id: number): Observable<any> {
    return this.get(`areacomum/`, id);
  }

  public getAreaComumByFilter(filter: AppFilter): Observable<any> {
    return this.get(`areacomum/filter/${filter.encode()}`);
  }

  public getAllAreasComuns(id: number): Observable<any> {
    if (!id)
      id = -1;

    return this.get(`areacomum/all/${id}`);
  }

  public salvarAreaComum(areacomum) {
    return this.save('areacomum/', areacomum);
  }

  public deletarAreaComum(id) {
    return this.delete('areacomum/', id);
  }

  public getRegraAgendamentoByAreaComumId(id: number): Observable<any> {
    return this.get(`regraagendamentos/areacomum/${id}`);
  }

  public getRegraAgendamentoByAreaComumIdV2(id: number): Observable<any> {
    return this.get(`api/v1/regras-agendamento/area-comum/`, id);
  }

  public getTermosDeUso(regraAgendamentoId: number): Observable<string> {
    return this.http.get(`${this.url}api/v1/regras-agendamento/${regraAgendamentoId}/termos-uso`, { responseType: 'text' });
  }

  public salvarRegraAgendamento(regraagendamento) {
    return this.save('regraagendamentos/', regraagendamento);
  }

  public getAllFeriadosByFilter(filter: AppFilter): Observable<any> {
    return this.get(`feriados/filter/${filter.encode()}`);
  }

  public saveFeriadoAreaComum(feriadoAreaComum: Array<FeriadoAreaComumDTO>) {
    return this.save('feriado_area_comuns/savelist', feriadoAreaComum);
  }

  public findFeriadoByAreaComumId(id: number): Observable<any> {
    return this.get(`feriado_area_comuns/all/areacomum/${id}`);
  }

  public findPeriodoByRegraAgendamentoId(filter: AppFilter): Observable<any> {
    return this.get(`periodos/filter/${filter.encode()}`);
  }

  public getHabilitarControleAcessoVinculado(id: number, controleAcessoVinculado: boolean): Observable<any> {
    return this.get(`regraagendamentos/areacomum/${id}/${controleAcessoVinculado}`);
  }
}
